import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import GymMemberRow from "./GymMemberRow";

const GymMembersTable = ({
  members,
  sortConfig,
  handleSort,
  csvString,
  search,
  setSearch,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <>
      <header className="table-header">
        <hgroup>
          <input
            type="search"
            className="text-input"
            name="search"
            placeholder={t("membershipList.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            data-expandable="true"
          />
        </hgroup>
        <hgroup>
          <a
            role="button"
            data-button-type="primary"
            data-icon
            href="/coaching-portal/gym-members/?modal[type]=add-member"
          >
            {t("gymMembers.addMember")}
          </a>
          <a
            role="button"
            target="_blank"
            href={`data:attachment/csv,${encodeURIComponent(csvString)}`}
            download={t("gymMembers.csvDownloadFilename")}
            data-button-type="secondary"
          >
            {t("gymMembers.exportCsv")}
          </a>
        </hgroup>
      </header>
      <section role="table-wrapper" data-borders-inside>
        <table role="report-table" className="subscribers-table">
          <thead role="table-header">
            <tr>
              <th>
                {t("gymMembers.columnMember")}{" "}
                <SvgIcon
                  src="/img/svg/up_down_arrows.svg"
                  onClickFn={() =>
                    handleSort(
                      { target: { value: "name" } },
                      sortConfig.key === "name" &&
                        sortConfig.direction !== "descending"
                        ? "descending"
                        : "ascending"
                    )
                  }
                />
              </th>
              <th>{t("membershipList.email")}</th>
              <th>{t("gymMembers.columnAccountIdExternal")}</th>
              <th>{t("gymMembers.columnMsbAccountId")}</th>
              <th className="text-center">{t("membershipList.action")}</th>
            </tr>
          </thead>
          {members && members.length > 0 ? (
            <tbody>
              {members.map((member) => (
                <GymMemberRow key={member._id} member={member} />
              ))}
            </tbody>
          ) : (
            <EmptyState searchString={search} />
          )}
        </table>
      </section>
    </>
  );
};

const EmptyState = ({ searchString }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <tbody>
      <tr>
        <td colSpan="100%">
          <div className="body-table-empty">
            {searchString ? (
              <>
                <span>{t("membershipList.noResultsFor")}</span>
                <p>{searchString}</p>
              </>
            ) : (
              <>
                <p>{t("gymMembers.emptyNoMembers")}</p>
                <span>{t("gymMembers.emptyNoMembersHint")}</span>
              </>
            )}
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default GymMembersTable;
